<template>
    <CustomHeader :text="$t('offers.depositReturn')" />
    <div class="offers_page">
        <div class="timer">
            <div class="topImage">
                <img src="@/assets/themeThree/money.png" alt="">
            </div>

            <div class="timeBox" v-if="dataSet.isActivityEnableTime">
                <div class="timeTitle">{{ $t('offers.remainTieTitle') }}</div>
                <div class="timer_countdown">
                    <div class="timer_box" v-if="dataSet.days > 0"> {{ dataSet.days > 0 ? dataSet.days : '' }}<span>{{
                        $t('common.days') }}</span></div>
                    <div class="timer_box">{{ dataSet.hours }}<span> {{ $t('offers.hours') }} </span></div>
                    <div class="timer_box">{{ dataSet.minutes }}<span> {{ $t('offers.minutes') }} </span></div>
                    <div class="timer_box">{{ dataSet.seconds }}<span> {{ $t('offers.seconds') }} </span></div>
                </div>
            </div>
            <div v-else class="timeBox">
                <div class="timeTitle">{{ $t('offers.untilStartPromoTitle') }}</div>
                <div class="timer_countdown">
                    <div class="timer_box" v-if="dataSet.days > 0" >{{ dataSet.days > 0 ? dataSet.days : '' }}<span> {{
                        $t('common.days') }}</span></div>
                    <div class="timer_box">{{ dataSet.hours }}<span> {{ $t('offers.hours') }} </span></div>
                    <div class="timer_box">{{ dataSet.minutes }}<span> {{ $t('offers.minutes') }} </span></div>
                    <div class="timer_box">{{ dataSet.seconds }}<span> {{ $t('offers.seconds') }} </span></div>
                </div>
            </div>


            <div class="promo_wrapper">
                <van-row style="padding: 15px;">
                    <van-col span="4" class="centerAlign"><img src="@/assets/firstRecharge/tittleLine.png"
                            width="100%" /></van-col>
                    <van-col span="16" class="centerAlign">
                        <div class="promo_title">
                            <div>{{ $t('offers.promotionTime') }}<div class="promo_title">{{
                                $t(`offers.${getDayNameFromTimestamp(dataSet.endTime)}`) }}</div>
                            </div>
                        </div>
                    </van-col>
                    <van-col span="4" class="centerAlign"><img src="@/assets/firstRecharge/tittleLine.png"
                            width="100%" /></van-col>
                </van-row>

                <div class="promotion_card_list">
                    <PromotionCard :cardData="item" :isActivityEnable="dataSet.isActivityEnableTime"
                        v-for="(item, index) in dataSet.activityList" :key="index"
                        :dayName="getDayNameFromTimestamp(dataSet.endTime)" />
                </div>
            </div>
            <div class="bottom_text">
                <van-row >
                    <van-col span="24" class="title">
                        <img src="@/assets/firstRecharge/tittleLine.png" />
                        <div>{{ $t('common.activityTitle') }}</div>
                        <img src="@/assets/firstRecharge/tittleLine.png" />
                    </van-col>
                </van-row>
                <div class="rulePage">
                    <div class="line_text" v-for="value in dataSet.activityIntro" :key="value">
                        {{ value }}
                    </div>
                </div>

            </div>
        </div>


    </div>
</template>
<script setup lang="ts">

import { useRouter } from 'vue-router';
import CustomHeader from '../components/common/customHeader.vue';
import PromotionCard from './components/promotionCard.vue';
import { OffersView } from '@/view/offers/supportScript';
const router = useRouter()
const props = defineProps<{
    dataSet: OffersView
}>()

const getDayNameFromTimestamp = (timestamp: number): string => {
    const date = new Date(timestamp);
    return date.toLocaleDateString("en-US", { weekday: "long" });
}
const routerchangeHandle = () => {
    router.push('/')
    localStorage.setItem('footerPopupOpen', '3')
}
</script>
<style scoped>
.offers_page {
    padding: 50px 0;
}

.offers_page img {
    width: 100%;
}

.timer {
    margin: 20% 15px 0;
    padding: 0px;
    position: relative;
    background: linear-gradient(180.38deg, #058a7f .25rem, #033233 18.875rem);
    border-radius: 20px;

}

.topImage {
    display: flex;
    justify-content: center;
    position: relative;
    z-index: 1;

}

.topImage img {
    width: 70%;
    margin-top: -25%;
    position: relative;
    z-index: 2;
}

.timeBox {
    border-radius: 10px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex-direction: column;
}

.timeTitle {
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    display: flex;
    justify-content: center;
}

.timer_box {
    display: flex;
    flex-direction: column;
    padding: 10px 5px;
    border-radius: 5px;
    align-items: center;
    margin: 5px;
    justify-content: center;
    text-align: center;
    background: linear-gradient(90deg, rgb(3, 97, 95) -18%, rgb(165, 160, 69) 122%);
    min-width: 20%;
}

.timer_countdown {
    font-size: 20px;
    font-weight: 800;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}

.timer_box span {
    font-size: 11px;
    font-weight: 500;
    text-transform: uppercase;
}

.promo_wrapper {
    margin-top: 15px;
}

.centerAlign {
    display: flex;
    align-items: center;
    justify-content: center;
}

.titleRow {
    display: flex;

}

.titleRow img {
    width: 10%;
}

.promo_title {
    font-size: 20px;
    font-weight: 800;
    margin-inline: 1rem;
    background: linear-gradient(90deg, rgb(8 100 46) -27.5%, rgb(13, 176, 174) 127.5%);
    background-clip: border-box;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    z-index: 0;
    text-align: center;
}

.promotion_card_list {
    padding: 0 10px;
}


.title {
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 15px 0 0;

}

.title img {
    width: 15%;
    padding: 10px;
}

.line_text {
    color: rgb(255, 255, 255, 0.2);
    font-size: 16px;
    padding: 10px 0px;
}

.rulePage {
    border-top: .0625rem solid transparent;
    border-image-slice: 1;
    padding: 1rem 1.75rem .625rem;
    border-radius: .625rem;
}

.topImage::before {
    content: "";
    position: absolute;
    top: 30%;
    left: 50%;
    width: 350px;
    height: 350px;
    background: conic-gradient(from 0deg,
            rgba(255, 238, 0, 0) 0deg,
            rgba(255, 231, 50, 0) 15deg,
            rgba(255, 252, 53, 0.466) 15deg,
            /* The color of the ray */
            rgba(255, 236, 27, 0.541) 30deg,
            rgba(247, 255, 19, 0.022) 30deg,
            rgba(255, 255, 85, 0) 45deg,
            rgba(255, 225, 0, 0.504) 45deg,
            rgba(255, 251, 24, 0.344) 60deg,
            rgba(255, 225, 73, 0) 60deg);
    background: repeating-conic-gradient(from 0deg,
            rgba(244, 236, 149, 0.1) 0deg 15deg,
            transparent 15deg 30deg);
    mask-image: radial-gradient(circle, black 20%, transparent 70%);
    -webkit-mask-image: radial-gradient(circle, black 20%, transparent 70%);

    transform-origin: center center;
    transform: translate(-50%, -50%);
    z-index: -1;
    animation: rotateRays 15s linear infinite;
}

@keyframes rotateRays {
    from {
        transform: translate(-50%, -50%) rotate(0deg);
    }

    to {
        transform: translate(-50%, -50%) rotate(360deg);
    }
}

@media screen and (max-width: 450px) {
    .promo_title {
        font-size: 14px;
    }
}
</style>